import { Unit } from "../../types/customization/box";
import { SelectionPhoto } from "../../types/selection/selection";
import BaseSelectionProvider from "./BaseSelectionProvider";

export default class UnsplashSelectionProvider extends BaseSelectionProvider {
  hasAlbums(): boolean {
    return false;
  }

  async getPhotos(): Promise<SelectionPhoto[]> {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve([
          {
            height: { unit: Unit.PX, value: 1700 } as const,
            key: "unsplash-1",
            provider: "unsplash",
            providerPictureUrl:
              "https://images.unsplash.com/photo-1478118330274-ff72cf1161a7?fit=crop&w=2550&q=80",
            providerRef: "abc-1",
            providerThumbnailUrl:
              "https://images.unsplash.com/photo-1478118330274-ff72cf1161a7?fit=crop&w=300&q=80",
            width: { unit: Unit.PX, value: 2550 } as const,
          },
          {
            height: { unit: Unit.PX, value: 900 } as const,
            key: "unsplash-2",
            provider: "unsplash",
            providerPictureUrl:
              "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?fit=crop&w=1350&q=80",
            providerRef: "abc-2",
            providerThumbnailUrl:
              "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?fit=crop&w=300&q=80",
            width: { unit: Unit.PX, value: 1350 } as const,
          },
          {
            height: { unit: Unit.PX, value: 3208 } as const,
            key: "unsplash-3",
            provider: "unsplash",
            providerPictureUrl:
              "https://images.unsplash.com/photo-1463763422025-e07f8081b9c9?fit=crop&w=2133&q=80",
            providerRef: "abc-3",
            providerThumbnailUrl:
              "https://images.unsplash.com/photo-1463763422025-e07f8081b9c9?fit=crop&w=300&q=80",
            width: { unit: Unit.PX, value: 2133 } as const,
          },
          {
            height: { unit: Unit.PX, value: 3196 } as const,
            key: "unsplash-4",
            provider: "unsplash",
            providerPictureUrl:
              "https://images.unsplash.com/photo-1522021838756-90c6bf671194?fit=crop&w=2134&q=80",
            providerRef: "abc-4",
            providerThumbnailUrl:
              "https://images.unsplash.com/photo-1522021838756-90c6bf671194?fit=crop&w=300&q=80",
            width: { unit: Unit.PX, value: 2134 } as const,
          },
          {
            height: { unit: Unit.PX, value: 450 } as const,
            key: "unsplash-5",
            provider: "unsplash",
            providerPictureUrl:
              "https://images.unsplash.com/photo-1557138926-823b0c483b9a?fit=crop&w=300&q=80",
            providerRef: "abc-5",
            providerThumbnailUrl:
              "https://images.unsplash.com/photo-1557138926-823b0c483b9a?fit=crop&w=300&q=80",
            width: { unit: Unit.PX, value: 300 } as const,
          },
          {
            height: { unit: Unit.PX, value: 1357 } as const,
            key: "unsplash-6",
            provider: "unsplash",
            providerPictureUrl:
              "https://images.unsplash.com/photo-1524055954608-d399863d5f52?fit=crop&w=1900&q=80",
            providerRef: "abc-6",
            providerThumbnailUrl:
              "https://images.unsplash.com/photo-1524055954608-d399863d5f52?fit=crop&w=300&q=80",
            width: { unit: Unit.PX, value: 1900 } as const,
          },
        ]);
      }, 500);
    });
  }
}
